var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(-19 -99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(28.181 108.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M3394.807,3519.477l-4.107-4.106a1.177,1.177,0,0,1,0-1.66l4.107-4.106a1.172,1.172,0,0,1,1.659,0l4.107,4.106a1.172,1.172,0,0,1,0,1.66l-4.107,4.106a1.172,1.172,0,0,1-1.659,0Zm7.04-7.039-4.107-4.106a1.175,1.175,0,0,1,0-1.659l4.107-4.106a1.172,1.172,0,0,1,1.659,0l4.107,4.106a1.174,1.174,0,0,1,0,1.659l-4.107,4.106a1.175,1.175,0,0,1-1.659,0Zm-14.079,0-4.107-4.106a1.176,1.176,0,0,1,0-1.659l4.107-4.106a1.172,1.172,0,0,1,1.659,0l4.107,4.106a1.173,1.173,0,0,1,0,1.659l-4.107,4.106a1.175,1.175,0,0,1-1.659,0Zm7.039-7.04-4.107-4.106a1.177,1.177,0,0,1,0-1.659l4.107-4.106a1.172,1.172,0,0,1,1.659,0l4.107,4.106a1.172,1.172,0,0,1,0,1.659l-4.107,4.106a1.172,1.172,0,0,1-1.659,0Z",
    transform: "translate(-3383.318 -3495.183)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 43,
    height: 43,
    transform: "translate(19 99)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.c3127016271e60fb94a74367686753ca.svg";
export { ForwardRef as ReactComponent };